import { Task } from "../types";
import {
  ADD_TO_TASKS_QUEUE,
  CHANGE_TASK_DISPLAY_STATUS,
  CHANGE_TASK_FAILURE,
  CHANGE_TASK_SUCCESS,
} from "./constants";

export function addToTaskQueue(taskId: string, action: any, status: Task["status"], display: boolean = true) {
  return {
    type: ADD_TO_TASKS_QUEUE,
    payload: { taskId, type: action.type, ...action.payload, ...action.data, status, display },
  };
}

export function changeTaskSuccess(taskId: string) {
  return {
    type: CHANGE_TASK_SUCCESS,
    payload: { taskId },
  };
}

export function changeTaskFailure(taskId: string, error: any) {
  return {
    type: CHANGE_TASK_FAILURE,
    payload: { taskId, error },
  };
}

export function changeTaskDisplay(taskId: string) {
  return {
    type: CHANGE_TASK_DISPLAY_STATUS,
    payload: { taskId },
  };
}
